/**
 * TanStack Query hooks for `student-startup-tier`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	studentStartupTierQueryKeys,
	type CreateStudentStartupTierBody,
	type ListStudentStartupTierResponse,
	type StudentStartupTierRow,
} from "./api";

export function useStudentStartupTierList(): UseQueryResult<ListStudentStartupTierResponse, Error> {
	return useQuery({
		queryKey: studentStartupTierQueryKeys.list(),
		queryFn: list,
	});
}

export function useStudentStartupTierCreate(): UseMutationResult<StudentStartupTierRow, Error, CreateStudentStartupTierBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: studentStartupTierQueryKeys.all });
		},
	});
}

export function useStudentStartupTierDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: studentStartupTierQueryKeys.all });
		},
	});
}
